module.exports = __webpack_public_path__ + "static/media/notification.6af0f57b.aac";